import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "aiQuizCreatorContainer"
};
const _hoisted_2 = {
  class: "aiQuizHeader"
};
const _hoisted_3 = {
  class: "aiQuizHeaderLeftPart"
};
const _hoisted_4 = {
  class: "aiQuizHeaderTitle"
};
const _hoisted_5 = {
  class: "aiQuizHeaderRightPart"
};
const _hoisted_6 = {
  class: "popupRow"
};
const _hoisted_7 = {
  class: "messagePopup"
};
const _hoisted_8 = {
  class: "inputPopup"
};
const _hoisted_9 = {
  class: "question-mode-selector"
};
const _hoisted_10 = {
  key: 0,
  class: "speachContentSourceBlock"
};
const _hoisted_11 = {
  class: "question-mode-selector"
};
const _hoisted_12 = {
  class: "documentSourceBlock"
};
const _hoisted_13 = {
  class: "question-mode-selector"
};
const _hoisted_14 = {
  class: "promptOnlySourceBlock"
};
const _hoisted_15 = {
  class: "messagePopup"
};
const _hoisted_16 = {
  class: "inputPopup"
};
const _hoisted_17 = {
  class: "question-mode-selector"
};
const _hoisted_18 = {
  class: "messagePopup"
};
const _hoisted_19 = {
  class: "dropdownPopup"
};
const _hoisted_20 = {
  class: "messagePopup"
};
const _hoisted_21 = {
  class: "inputPopup promptHelperBlock"
};
const _hoisted_22 = {
  class: "dialog-footer"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_AIQuizSubChapterSelect = _resolveComponent("AIQuizSubChapterSelect");
  const _component_a_i_quiz_generation_document_upload = _resolveComponent("a-i-quiz-generation-document-upload");
  const _component_a_i_quiz_generation_text_field = _resolveComponent("a-i-quiz-generation-text-field");
  const _component_w_radio_group = _resolveComponent("w-radio-group");
  const _component_w_slider = _resolveComponent("w-slider");
  const _component_w_select = _resolveComponent("w-select");
  const _component_Loader = _resolveComponent("Loader");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
      icon: "creation-outline",
      size: "default",
      class: _normalizeClass('aiQuizHeaderTitleIcon')
    }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("aiQuizGeneration.header")), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_w_tool_tip, {
      text: _ctx.$t('aiQuizGeneration.noMoreThan50Questions'),
      disabled: _ctx.autoMaxNbQuestionsAllowed > 0,
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        outlined: true,
        disabled: _ctx.autoMaxNbQuestionsAllowed <= 0,
        onAction: _cache[0] || (_cache[0] = $event => _ctx.openPopUp())
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "creation-outline"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t("aiQuizGeneration.generateTitle")), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }, 8, ["text", "disabled"])])])])]),
    _: 1
  }), _createVNode(_component_w_dialog, {
    visible: _ctx.generationPopup,
    title: _ctx.$t('aiQuizGeneration.generateTitle'),
    onOnDialogClose: _ctx.closeGenerationPopup,
    "append-to-body": true
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_22, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
      onAction: _ctx.closeGenerationPopup
    }, null, 8, ["label", "onAction"]), _createVNode(_component_w_tool_tip, {
      text: _ctx.$t('aiQuizGeneration.noMoreThan50Questions'),
      disabled: _ctx.autoMaxNbQuestionsAllowed > 0,
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        onAction: _ctx.generateAIQuiz,
        disabled: _ctx.generationInProgress || _ctx.autoMaxNbQuestionsAllowed <= 0 || !_ctx.quizGenerationInputIsValid()
      }, {
        default: _withCtx(() => [!_ctx.generationInProgress ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('aiQuizGeneration.popup.buttonGenerate')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_24, [_createVNode(_component_w_tool_tip, {
          text: _ctx.$t('aiQuizGeneration.popup.generationTooltip')
        }, {
          default: _withCtx(() => [_createVNode(_component_Loader, {
            "spinner-size": "small",
            class: "spinnerElement",
            "spinner-color": "lightSpinner"
          })]),
          _: 1
        }, 8, ["text"])]))]),
        _: 1
      }, 8, ["onAction", "disabled"])]),
      _: 1
    }, 8, ["text", "disabled"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("aiQuizGeneration.popup.selectChapters")), 1), _createElementVNode("div", _hoisted_8, [!_ctx.isAutoTransriptFullyReady ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 0,
      text: _ctx.$t('aiQuizGeneration.popup.needToProceed')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "alert-outline",
        class: "warningProceed"
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_radio, {
      modelValue: _ctx.questionGenerationSource,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.questionGenerationSource = $event),
      value: _ctx.AiQuizQuestionsGenerationSourceEnum.SPEACH_CONTENT,
      label: _ctx.$t('aiQuizGeneration.popup.speachContentOption'),
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "value", "label", "disabled"]), _ctx.fullSpeach ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_withDirectives(_createVNode(_component_AIQuizSubChapterSelect, {
      speach: _ctx.fullSpeach,
      disabled: _ctx.generationInProgress,
      onSelect: _ctx.changeSelectedChapters,
      onForceRegenerateTranscript: _ctx.forceRegenerateTranscript
    }, null, 8, ["speach", "disabled", "onSelect", "onForceRegenerateTranscript"]), [[_vShow, _ctx.questionGenerationSource === _ctx.AiQuizQuestionsGenerationSourceEnum.SPEACH_CONTENT]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_radio, {
      modelValue: _ctx.questionGenerationSource,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.questionGenerationSource = $event),
      value: _ctx.AiQuizQuestionsGenerationSourceEnum.DOCUMENT,
      label: _ctx.$t('aiQuizGeneration.uploadedDocument.title'),
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "value", "label", "disabled"]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createVNode(_component_a_i_quiz_generation_document_upload, {
      "failed-docs": _ctx.customDocsInError,
      disabled: _ctx.generationInProgress,
      onDataChange: _ctx.onGenerationByUploadDataChange
    }, null, 8, ["failed-docs", "disabled", "onDataChange"]), [[_vShow, _ctx.questionGenerationSource === _ctx.AiQuizQuestionsGenerationSourceEnum.DOCUMENT]])])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_radio, {
      modelValue: _ctx.questionGenerationSource,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.questionGenerationSource = $event),
      value: _ctx.AiQuizQuestionsGenerationSourceEnum.TEXT_CONTENT,
      label: _ctx.$t('aiQuizGeneration.textContent.title'),
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "value", "label", "disabled"]), _createElementVNode("div", _hoisted_14, [_withDirectives(_createVNode(_component_a_i_quiz_generation_text_field, {
      placeholder: _ctx.$t('aiQuizGeneration.textContent.placeholder'),
      disabled: _ctx.generationInProgress,
      onContentChange: _ctx.onTextContentChange
    }, null, 8, ["placeholder", "disabled", "onContentChange"]), [[_vShow, _ctx.questionGenerationSource === _ctx.AiQuizQuestionsGenerationSourceEnum.TEXT_CONTENT]])])])]), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("aiQuizGeneration.popup.message")), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_w_radio_group, {
      class: "radio-group",
      modelValue: _ctx.questionGenerationMode,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.questionGenerationMode = $event),
      onChange: _ctx.onQuestionModeChange,
      options: _ctx.questionModeOptions,
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "onChange", "options", "disabled"])]), _withDirectives(_createVNode(_component_w_slider, {
      modelValue: _ctx.nbCustomQuestions,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.nbCustomQuestions = $event),
      onInput: _ctx.onNbCustomQuestionsChange,
      marks: _ctx.marks,
      min: _ctx.customMaxNbQuestionsAllowed > 0 ? 1 : 0,
      max: _ctx.customMaxNbQuestionsAllowed,
      "show-input": true,
      disabled: _ctx.questionGenerationMode === 'auto' || _ctx.generationInProgress
    }, null, 8, ["modelValue", "onInput", "marks", "min", "max", "disabled"]), [[_vShow, _ctx.questionGenerationMode !== 'auto']])]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('aiQuizGeneration.language.title')), 1), _createElementVNode("div", _hoisted_19, [_createVNode(_component_w_select, {
      placeholder: _ctx.$t('aiQuizGeneration.language.placeholder'),
      options: _ctx.listOfLanguage,
      value: _ctx.selectedLang,
      size: "default",
      enabled: !_ctx.generationInProgress,
      onChange: _ctx.onLanguageChange
    }, null, 8, ["placeholder", "options", "value", "enabled", "onChange"])]), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('aiQuizGeneration.customInstructions.title')), 1), _createElementVNode("div", _hoisted_21, [_createVNode(_Transition, {
      name: "zoom"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_i_quiz_generation_text_field, {
        placeholder: _ctx.$t('aiQuizGeneration.customInstructions.placeholder'),
        disabled: _ctx.generationInProgress,
        onContentChange: _ctx.onPromptHelperChange
      }, null, 8, ["placeholder", "disabled", "onContentChange"])]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"])]);
}